var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImpulsoBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1516.071,
    height: 721.472,
    viewBox: "0 0 1516.071 721.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_120",
    "data-name": "Grupo 120",
    transform: "translate(43 -81.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2",
    transform: "translate(-43 81.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M69,789.547V773.793l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -116.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M216.46,789.547V773.793l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -116.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M348.79,789.547V773.793l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -116.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M69,681.257V665.5l47.415-15.763L163.839,665.5v15.754L116.415,665.5Z",
    transform: "translate(-10.62 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M216.46,681.257V665.5l47.415-15.763L311.29,665.5v15.754L263.875,665.5Z",
    transform: "translate(-33.315 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21",
    "data-name": "Trazado 21",
    d: "M348.79,681.257V665.5l47.415-15.763L443.629,665.5v15.754L396.205,665.5Z",
    transform: "translate(-53.681 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22",
    "data-name": "Trazado 22",
    d: "M69,572.967V557.213l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M216.46,572.967V557.213l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24",
    "data-name": "Trazado 24",
    d: "M348.79,572.967V557.213l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M69,464.677V448.923l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M216.46,464.677V448.923l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M348.79,464.677V448.923l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28",
    "data-name": "Trazado 28",
    d: "M69,356.387V340.633l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M216.46,356.387V340.633l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30",
    "data-name": "Trazado 30",
    d: "M348.79,356.387V340.633l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31",
    "data-name": "Trazado 31",
    d: "M69,248.1V232.343l47.415-15.763,47.424,15.763V248.1l-47.424-15.754Z",
    transform: "translate(-10.62 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32",
    "data-name": "Trazado 32",
    d: "M216.46,248.1V232.343l47.415-15.763,47.415,15.763V248.1l-47.415-15.754Z",
    transform: "translate(-33.315 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_33",
    "data-name": "Trazado 33",
    d: "M348.79,248.1V232.343l47.415-15.763,47.424,15.763V248.1l-47.424-15.754Z",
    transform: "translate(-53.681 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_34",
    "data-name": "Trazado 34",
    d: "M69,139.807V124.053l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_35",
    "data-name": "Trazado 35",
    d: "M216.46,139.807V124.053l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36",
    "data-name": "Trazado 36",
    d: "M348.79,139.807V124.053l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_37",
    "data-name": "Trazado 37",
    d: "M69,31.517V15.763L116.415,0l47.424,15.763V31.517L116.415,15.763Z",
    transform: "translate(-10.62)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_38",
    "data-name": "Trazado 38",
    d: "M216.46,31.517V15.763L263.875,0,311.29,15.763V31.517L263.875,15.763Z",
    transform: "translate(-33.315)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39",
    "data-name": "Trazado 39",
    d: "M348.79,31.517V15.763L396.205,0l47.424,15.763V31.517L396.205,15.763Z",
    transform: "translate(-53.681)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40",
    "data-name": "Trazado 40",
    d: "M140.64,735.407V719.644l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41",
    "data-name": "Trazado 41",
    d: "M281.28,735.407V719.644L328.7,703.89l47.424,15.754v15.763L328.7,719.644Z",
    transform: "translate(-43.291 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42",
    "data-name": "Trazado 42",
    d: "M0,735.407V719.644L47.415,703.89l47.424,15.754v15.763L47.415,719.644Z",
    transform: "translate(0 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43",
    "data-name": "Trazado 43",
    d: "M140.64,846.977V831.214l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44",
    "data-name": "Trazado 44",
    d: "M281.28,846.977V831.214L328.7,815.46l47.424,15.754v15.763L328.7,831.214Z",
    transform: "translate(-43.291 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45",
    "data-name": "Trazado 45",
    d: "M0,846.977V831.214L47.415,815.46l47.424,15.754v15.763L47.415,831.214Z",
    transform: "translate(0 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46",
    "data-name": "Trazado 46",
    d: "M69,681.257V665.5l47.415-15.763L163.839,665.5v15.754L116.415,665.5Z",
    transform: "translate(-10.62 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_47",
    "data-name": "Trazado 47",
    d: "M216.46,681.257V665.5l47.415-15.763L311.29,665.5v15.754L263.875,665.5Z",
    transform: "translate(-33.315 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_48",
    "data-name": "Trazado 48",
    d: "M140.64,627.117V611.354L188.055,595.6l47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_49",
    "data-name": "Trazado 49",
    d: "M281.28,627.117V611.354L328.7,595.6l47.424,15.754v15.763L328.7,611.354Z",
    transform: "translate(-43.291 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_50",
    "data-name": "Trazado 50",
    d: "M0,627.117V611.354L47.415,595.6l47.424,15.754v15.763L47.415,611.354Z",
    transform: "translate(0 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51",
    "data-name": "Trazado 51",
    d: "M69,572.967V557.213l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_52",
    "data-name": "Trazado 52",
    d: "M216.46,572.967V557.213l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_53",
    "data-name": "Trazado 53",
    d: "M140.64,518.827V503.064l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_54",
    "data-name": "Trazado 54",
    d: "M281.28,518.827V503.064L328.7,487.31l47.424,15.754v15.763L328.7,503.064Z",
    transform: "translate(-43.291 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_55",
    "data-name": "Trazado 55",
    d: "M0,518.827V503.064L47.415,487.31l47.424,15.754v15.763L47.415,503.064Z",
    transform: "translate(0 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_56",
    "data-name": "Trazado 56",
    d: "M69,464.677V448.923l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_57",
    "data-name": "Trazado 57",
    d: "M216.46,464.677V448.923l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_58",
    "data-name": "Trazado 58",
    d: "M140.64,410.537V394.774l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_59",
    "data-name": "Trazado 59",
    d: "M281.28,410.537V394.774L328.7,379.02l47.424,15.754v15.763L328.7,394.774Z",
    transform: "translate(-43.291 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60",
    "data-name": "Trazado 60",
    d: "M0,410.537V394.774L47.415,379.02l47.424,15.754v15.763L47.415,394.774Z",
    transform: "translate(0 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_61",
    "data-name": "Trazado 61",
    d: "M69,356.387V340.633l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_62",
    "data-name": "Trazado 62",
    d: "M216.46,356.387V340.633l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_63",
    "data-name": "Trazado 63",
    d: "M140.64,302.247V286.484l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_64",
    "data-name": "Trazado 64",
    d: "M281.28,302.247V286.484L328.7,270.73l47.424,15.754v15.763L328.7,286.484Z",
    transform: "translate(-43.291 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_65",
    "data-name": "Trazado 65",
    d: "M0,302.247V286.484L47.415,270.73l47.424,15.754v15.763L47.415,286.484Z",
    transform: "translate(0 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66",
    "data-name": "Trazado 66",
    d: "M69,248.1V232.343l47.415-15.763,47.424,15.763V248.1l-47.424-15.754Z",
    transform: "translate(-10.62 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_67",
    "data-name": "Trazado 67",
    d: "M216.46,248.1V232.343l47.415-15.763,47.415,15.763V248.1l-47.415-15.754Z",
    transform: "translate(-33.315 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_68",
    "data-name": "Trazado 68",
    d: "M140.64,193.957V178.194l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69",
    "data-name": "Trazado 69",
    d: "M281.28,193.957V178.194L328.7,162.44l47.424,15.754v15.763L328.7,178.194Z",
    transform: "translate(-43.291 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_70",
    "data-name": "Trazado 70",
    d: "M0,193.957V178.194L47.415,162.44l47.424,15.754v15.763L47.415,178.194Z",
    transform: "translate(0 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_71",
    "data-name": "Trazado 71",
    d: "M69,139.807V124.053l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72",
    "data-name": "Trazado 72",
    d: "M216.46,139.807V124.053l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_73",
    "data-name": "Trazado 73",
    d: "M140.64,85.659V69.9L188.055,54.15,235.479,69.9V85.659L188.055,69.9Z",
    transform: "translate(-21.645 -8.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_74",
    "data-name": "Trazado 74",
    d: "M281.28,85.659V69.9L328.7,54.15,376.119,69.9V85.659L328.7,69.9Z",
    transform: "translate(-43.291 -8.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75",
    "data-name": "Trazado 75",
    d: "M419.85,735.407V719.644l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76",
    "data-name": "Trazado 76",
    d: "M419.85,846.977V831.214l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_77",
    "data-name": "Trazado 77",
    d: "M419.85,627.117V611.354L467.265,595.6l47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_78",
    "data-name": "Trazado 78",
    d: "M419.85,518.827V503.064l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_79",
    "data-name": "Trazado 79",
    d: "M419.85,410.537V394.774l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_80",
    "data-name": "Trazado 80",
    d: "M419.85,302.247V286.484l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_81",
    "data-name": "Trazado 81",
    d: "M419.85,193.957V178.194l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_82",
    "data-name": "Trazado 82",
    d: "M419.85,85.659V69.9L467.265,54.15,514.689,69.9V85.659L467.265,69.9Z",
    transform: "translate(-64.618 -8.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83",
    "data-name": "Trazado 83",
    d: "M0,85.659V69.9L47.415,54.15,94.839,69.9V85.659L47.415,69.9Z",
    transform: "translate(0 -8.334)",
    fill: "#ee4c39"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2",
    transform: "translate(666 81.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16-2",
    "data-name": "Trazado 16",
    d: "M69,789.547V773.793l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -116.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17-2",
    "data-name": "Trazado 17",
    d: "M216.46,789.547V773.793l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -116.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18-2",
    "data-name": "Trazado 18",
    d: "M348.79,789.547V773.793l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -116.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19-2",
    "data-name": "Trazado 19",
    d: "M69,681.257V665.5l47.415-15.763L163.839,665.5v15.754L116.415,665.5Z",
    transform: "translate(-10.62 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20-2",
    "data-name": "Trazado 20",
    d: "M216.46,681.257V665.5l47.415-15.763L311.29,665.5v15.754L263.875,665.5Z",
    transform: "translate(-33.315 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21-2",
    "data-name": "Trazado 21",
    d: "M348.79,681.257V665.5l47.415-15.763L443.629,665.5v15.754L396.205,665.5Z",
    transform: "translate(-53.681 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22-2",
    "data-name": "Trazado 22",
    d: "M69,572.967V557.213l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23-2",
    "data-name": "Trazado 23",
    d: "M216.46,572.967V557.213l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24-2",
    "data-name": "Trazado 24",
    d: "M348.79,572.967V557.213l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25-2",
    "data-name": "Trazado 25",
    d: "M69,464.677V448.923l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26-2",
    "data-name": "Trazado 26",
    d: "M216.46,464.677V448.923l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27-2",
    "data-name": "Trazado 27",
    d: "M348.79,464.677V448.923l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28-2",
    "data-name": "Trazado 28",
    d: "M69,356.387V340.633l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29-2",
    "data-name": "Trazado 29",
    d: "M216.46,356.387V340.633l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30-2",
    "data-name": "Trazado 30",
    d: "M348.79,356.387V340.633l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31-2",
    "data-name": "Trazado 31",
    d: "M69,248.1V232.343l47.415-15.763,47.424,15.763V248.1l-47.424-15.754Z",
    transform: "translate(-10.62 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32-2",
    "data-name": "Trazado 32",
    d: "M216.46,248.1V232.343l47.415-15.763,47.415,15.763V248.1l-47.415-15.754Z",
    transform: "translate(-33.315 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_33-2",
    "data-name": "Trazado 33",
    d: "M348.79,248.1V232.343l47.415-15.763,47.424,15.763V248.1l-47.424-15.754Z",
    transform: "translate(-53.681 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_34-2",
    "data-name": "Trazado 34",
    d: "M69,139.807V124.053l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_35-2",
    "data-name": "Trazado 35",
    d: "M216.46,139.807V124.053l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36-2",
    "data-name": "Trazado 36",
    d: "M348.79,139.807V124.053l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_37-2",
    "data-name": "Trazado 37",
    d: "M69,31.517V15.763L116.415,0l47.424,15.763V31.517L116.415,15.763Z",
    transform: "translate(-10.62)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_38-2",
    "data-name": "Trazado 38",
    d: "M216.46,31.517V15.763L263.875,0,311.29,15.763V31.517L263.875,15.763Z",
    transform: "translate(-33.315)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39-2",
    "data-name": "Trazado 39",
    d: "M348.79,31.517V15.763L396.205,0l47.424,15.763V31.517L396.205,15.763Z",
    transform: "translate(-53.681)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40-2",
    "data-name": "Trazado 40",
    d: "M140.64,735.407V719.644l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41-2",
    "data-name": "Trazado 41",
    d: "M281.28,735.407V719.644L328.7,703.89l47.424,15.754v15.763L328.7,719.644Z",
    transform: "translate(-43.291 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42-2",
    "data-name": "Trazado 42",
    d: "M0,735.407V719.644L47.415,703.89l47.424,15.754v15.763L47.415,719.644Z",
    transform: "translate(0 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43-2",
    "data-name": "Trazado 43",
    d: "M140.64,846.977V831.214l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44-2",
    "data-name": "Trazado 44",
    d: "M281.28,846.977V831.214L328.7,815.46l47.424,15.754v15.763L328.7,831.214Z",
    transform: "translate(-43.291 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45-2",
    "data-name": "Trazado 45",
    d: "M0,846.977V831.214L47.415,815.46l47.424,15.754v15.763L47.415,831.214Z",
    transform: "translate(0 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46-2",
    "data-name": "Trazado 46",
    d: "M69,681.257V665.5l47.415-15.763L163.839,665.5v15.754L116.415,665.5Z",
    transform: "translate(-10.62 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_47-2",
    "data-name": "Trazado 47",
    d: "M216.46,681.257V665.5l47.415-15.763L311.29,665.5v15.754L263.875,665.5Z",
    transform: "translate(-33.315 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_48-2",
    "data-name": "Trazado 48",
    d: "M140.64,627.117V611.354L188.055,595.6l47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_49-2",
    "data-name": "Trazado 49",
    d: "M281.28,627.117V611.354L328.7,595.6l47.424,15.754v15.763L328.7,611.354Z",
    transform: "translate(-43.291 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_50-2",
    "data-name": "Trazado 50",
    d: "M0,627.117V611.354L47.415,595.6l47.424,15.754v15.763L47.415,611.354Z",
    transform: "translate(0 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51-2",
    "data-name": "Trazado 51",
    d: "M69,572.967V557.213l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_52-2",
    "data-name": "Trazado 52",
    d: "M216.46,572.967V557.213l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_53-2",
    "data-name": "Trazado 53",
    d: "M140.64,518.827V503.064l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_54-2",
    "data-name": "Trazado 54",
    d: "M281.28,518.827V503.064L328.7,487.31l47.424,15.754v15.763L328.7,503.064Z",
    transform: "translate(-43.291 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_55-2",
    "data-name": "Trazado 55",
    d: "M0,518.827V503.064L47.415,487.31l47.424,15.754v15.763L47.415,503.064Z",
    transform: "translate(0 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_56-2",
    "data-name": "Trazado 56",
    d: "M69,464.677V448.923l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_57-2",
    "data-name": "Trazado 57",
    d: "M216.46,464.677V448.923l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_58-2",
    "data-name": "Trazado 58",
    d: "M140.64,410.537V394.774l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_59-2",
    "data-name": "Trazado 59",
    d: "M281.28,410.537V394.774L328.7,379.02l47.424,15.754v15.763L328.7,394.774Z",
    transform: "translate(-43.291 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60-2",
    "data-name": "Trazado 60",
    d: "M0,410.537V394.774L47.415,379.02l47.424,15.754v15.763L47.415,394.774Z",
    transform: "translate(0 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_61-2",
    "data-name": "Trazado 61",
    d: "M69,356.387V340.633l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_62-2",
    "data-name": "Trazado 62",
    d: "M216.46,356.387V340.633l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_63-2",
    "data-name": "Trazado 63",
    d: "M140.64,302.247V286.484l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_64-2",
    "data-name": "Trazado 64",
    d: "M281.28,302.247V286.484L328.7,270.73l47.424,15.754v15.763L328.7,286.484Z",
    transform: "translate(-43.291 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_65-2",
    "data-name": "Trazado 65",
    d: "M0,302.247V286.484L47.415,270.73l47.424,15.754v15.763L47.415,286.484Z",
    transform: "translate(0 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66-2",
    "data-name": "Trazado 66",
    d: "M69,248.1V232.343l47.415-15.763,47.424,15.763V248.1l-47.424-15.754Z",
    transform: "translate(-10.62 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_67-2",
    "data-name": "Trazado 67",
    d: "M216.46,248.1V232.343l47.415-15.763,47.415,15.763V248.1l-47.415-15.754Z",
    transform: "translate(-33.315 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_68-2",
    "data-name": "Trazado 68",
    d: "M140.64,193.957V178.194l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69-2",
    "data-name": "Trazado 69",
    d: "M281.28,193.957V178.194L328.7,162.44l47.424,15.754v15.763L328.7,178.194Z",
    transform: "translate(-43.291 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_70-2",
    "data-name": "Trazado 70",
    d: "M0,193.957V178.194L47.415,162.44l47.424,15.754v15.763L47.415,178.194Z",
    transform: "translate(0 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_71-2",
    "data-name": "Trazado 71",
    d: "M69,139.807V124.053l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72-2",
    "data-name": "Trazado 72",
    d: "M216.46,139.807V124.053l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_73-2",
    "data-name": "Trazado 73",
    d: "M140.64,85.659V69.9L188.055,54.15,235.479,69.9V85.659L188.055,69.9Z",
    transform: "translate(-21.645 -8.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_74-2",
    "data-name": "Trazado 74",
    d: "M281.28,85.659V69.9L328.7,54.15,376.119,69.9V85.659L328.7,69.9Z",
    transform: "translate(-43.291 -8.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75-2",
    "data-name": "Trazado 75",
    d: "M419.85,735.407V719.644l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76-2",
    "data-name": "Trazado 76",
    d: "M419.85,846.977V831.214l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_77-2",
    "data-name": "Trazado 77",
    d: "M419.85,627.117V611.354L467.265,595.6l47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_78-2",
    "data-name": "Trazado 78",
    d: "M419.85,518.827V503.064l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_79-2",
    "data-name": "Trazado 79",
    d: "M419.85,410.537V394.774l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_80-2",
    "data-name": "Trazado 80",
    d: "M419.85,302.247V286.484l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_81-2",
    "data-name": "Trazado 81",
    d: "M419.85,193.957V178.194l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_82-2",
    "data-name": "Trazado 82",
    d: "M419.85,85.659V69.9L467.265,54.15,514.689,69.9V85.659L467.265,69.9Z",
    transform: "translate(-64.618 -8.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83-2",
    "data-name": "Trazado 83",
    d: "M0,85.659V69.9L47.415,54.15,94.839,69.9V85.659L47.415,69.9Z",
    transform: "translate(0 -8.334)",
    fill: "#ee4c39"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-3",
    "data-name": "Capa 2",
    transform: "translate(314 81.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-3",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16-3",
    "data-name": "Trazado 16",
    d: "M69,789.547V773.793l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -116.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17-3",
    "data-name": "Trazado 17",
    d: "M216.46,789.547V773.793l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -116.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18-3",
    "data-name": "Trazado 18",
    d: "M348.79,789.547V773.793l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -116.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19-3",
    "data-name": "Trazado 19",
    d: "M69,681.257V665.5l47.415-15.763L163.839,665.5v15.754L116.415,665.5Z",
    transform: "translate(-10.62 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20-3",
    "data-name": "Trazado 20",
    d: "M216.46,681.257V665.5l47.415-15.763L311.29,665.5v15.754L263.875,665.5Z",
    transform: "translate(-33.315 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21-3",
    "data-name": "Trazado 21",
    d: "M348.79,681.257V665.5l47.415-15.763L443.629,665.5v15.754L396.205,665.5Z",
    transform: "translate(-53.681 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22-3",
    "data-name": "Trazado 22",
    d: "M69,572.967V557.213l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23-3",
    "data-name": "Trazado 23",
    d: "M216.46,572.967V557.213l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24-3",
    "data-name": "Trazado 24",
    d: "M348.79,572.967V557.213l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25-3",
    "data-name": "Trazado 25",
    d: "M69,464.677V448.923l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26-3",
    "data-name": "Trazado 26",
    d: "M216.46,464.677V448.923l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27-3",
    "data-name": "Trazado 27",
    d: "M348.79,464.677V448.923l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28-3",
    "data-name": "Trazado 28",
    d: "M69,356.387V340.633l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29-3",
    "data-name": "Trazado 29",
    d: "M216.46,356.387V340.633l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30-3",
    "data-name": "Trazado 30",
    d: "M348.79,356.387V340.633l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31-3",
    "data-name": "Trazado 31",
    d: "M69,248.1V232.343l47.415-15.763,47.424,15.763V248.1l-47.424-15.754Z",
    transform: "translate(-10.62 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32-3",
    "data-name": "Trazado 32",
    d: "M216.46,248.1V232.343l47.415-15.763,47.415,15.763V248.1l-47.415-15.754Z",
    transform: "translate(-33.315 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_33-3",
    "data-name": "Trazado 33",
    d: "M348.79,248.1V232.343l47.415-15.763,47.424,15.763V248.1l-47.424-15.754Z",
    transform: "translate(-53.681 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_34-3",
    "data-name": "Trazado 34",
    d: "M69,139.807V124.053l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_35-3",
    "data-name": "Trazado 35",
    d: "M216.46,139.807V124.053l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36-3",
    "data-name": "Trazado 36",
    d: "M348.79,139.807V124.053l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_37-3",
    "data-name": "Trazado 37",
    d: "M69,31.517V15.763L116.415,0l47.424,15.763V31.517L116.415,15.763Z",
    transform: "translate(-10.62)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_38-3",
    "data-name": "Trazado 38",
    d: "M216.46,31.517V15.763L263.875,0,311.29,15.763V31.517L263.875,15.763Z",
    transform: "translate(-33.315)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39-3",
    "data-name": "Trazado 39",
    d: "M348.79,31.517V15.763L396.205,0l47.424,15.763V31.517L396.205,15.763Z",
    transform: "translate(-53.681)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40-3",
    "data-name": "Trazado 40",
    d: "M140.64,735.407V719.644l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41-3",
    "data-name": "Trazado 41",
    d: "M281.28,735.407V719.644L328.7,703.89l47.424,15.754v15.763L328.7,719.644Z",
    transform: "translate(-43.291 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42-3",
    "data-name": "Trazado 42",
    d: "M0,735.407V719.644L47.415,703.89l47.424,15.754v15.763L47.415,719.644Z",
    transform: "translate(0 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43-3",
    "data-name": "Trazado 43",
    d: "M140.64,846.977V831.214l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44-3",
    "data-name": "Trazado 44",
    d: "M281.28,846.977V831.214L328.7,815.46l47.424,15.754v15.763L328.7,831.214Z",
    transform: "translate(-43.291 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45-3",
    "data-name": "Trazado 45",
    d: "M0,846.977V831.214L47.415,815.46l47.424,15.754v15.763L47.415,831.214Z",
    transform: "translate(0 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46-3",
    "data-name": "Trazado 46",
    d: "M69,681.257V665.5l47.415-15.763L163.839,665.5v15.754L116.415,665.5Z",
    transform: "translate(-10.62 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_47-3",
    "data-name": "Trazado 47",
    d: "M216.46,681.257V665.5l47.415-15.763L311.29,665.5v15.754L263.875,665.5Z",
    transform: "translate(-33.315 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_48-3",
    "data-name": "Trazado 48",
    d: "M140.64,627.117V611.354L188.055,595.6l47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_49-3",
    "data-name": "Trazado 49",
    d: "M281.28,627.117V611.354L328.7,595.6l47.424,15.754v15.763L328.7,611.354Z",
    transform: "translate(-43.291 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_50-3",
    "data-name": "Trazado 50",
    d: "M0,627.117V611.354L47.415,595.6l47.424,15.754v15.763L47.415,611.354Z",
    transform: "translate(0 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51-3",
    "data-name": "Trazado 51",
    d: "M69,572.967V557.213l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_52-3",
    "data-name": "Trazado 52",
    d: "M216.46,572.967V557.213l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_53-3",
    "data-name": "Trazado 53",
    d: "M140.64,518.827V503.064l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_54-3",
    "data-name": "Trazado 54",
    d: "M281.28,518.827V503.064L328.7,487.31l47.424,15.754v15.763L328.7,503.064Z",
    transform: "translate(-43.291 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_55-3",
    "data-name": "Trazado 55",
    d: "M0,518.827V503.064L47.415,487.31l47.424,15.754v15.763L47.415,503.064Z",
    transform: "translate(0 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_56-3",
    "data-name": "Trazado 56",
    d: "M69,464.677V448.923l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_57-3",
    "data-name": "Trazado 57",
    d: "M216.46,464.677V448.923l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_58-3",
    "data-name": "Trazado 58",
    d: "M140.64,410.537V394.774l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_59-3",
    "data-name": "Trazado 59",
    d: "M281.28,410.537V394.774L328.7,379.02l47.424,15.754v15.763L328.7,394.774Z",
    transform: "translate(-43.291 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60-3",
    "data-name": "Trazado 60",
    d: "M0,410.537V394.774L47.415,379.02l47.424,15.754v15.763L47.415,394.774Z",
    transform: "translate(0 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_61-3",
    "data-name": "Trazado 61",
    d: "M69,356.387V340.633l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_62-3",
    "data-name": "Trazado 62",
    d: "M216.46,356.387V340.633l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_63-3",
    "data-name": "Trazado 63",
    d: "M140.64,302.247V286.484l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_64-3",
    "data-name": "Trazado 64",
    d: "M281.28,302.247V286.484L328.7,270.73l47.424,15.754v15.763L328.7,286.484Z",
    transform: "translate(-43.291 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_65-3",
    "data-name": "Trazado 65",
    d: "M0,302.247V286.484L47.415,270.73l47.424,15.754v15.763L47.415,286.484Z",
    transform: "translate(0 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66-3",
    "data-name": "Trazado 66",
    d: "M69,248.1V232.343l47.415-15.763,47.424,15.763V248.1l-47.424-15.754Z",
    transform: "translate(-10.62 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_67-3",
    "data-name": "Trazado 67",
    d: "M216.46,248.1V232.343l47.415-15.763,47.415,15.763V248.1l-47.415-15.754Z",
    transform: "translate(-33.315 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_68-3",
    "data-name": "Trazado 68",
    d: "M140.64,193.957V178.194l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69-3",
    "data-name": "Trazado 69",
    d: "M281.28,193.957V178.194L328.7,162.44l47.424,15.754v15.763L328.7,178.194Z",
    transform: "translate(-43.291 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_70-3",
    "data-name": "Trazado 70",
    d: "M0,193.957V178.194L47.415,162.44l47.424,15.754v15.763L47.415,178.194Z",
    transform: "translate(0 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_71-3",
    "data-name": "Trazado 71",
    d: "M69,139.807V124.053l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72-3",
    "data-name": "Trazado 72",
    d: "M216.46,139.807V124.053l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_73-3",
    "data-name": "Trazado 73",
    d: "M140.64,85.659V69.9L188.055,54.15,235.479,69.9V85.659L188.055,69.9Z",
    transform: "translate(-21.645 -8.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_74-3",
    "data-name": "Trazado 74",
    d: "M281.28,85.659V69.9L328.7,54.15,376.119,69.9V85.659L328.7,69.9Z",
    transform: "translate(-43.291 -8.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75-3",
    "data-name": "Trazado 75",
    d: "M419.85,735.407V719.644l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76-3",
    "data-name": "Trazado 76",
    d: "M419.85,846.977V831.214l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_77-3",
    "data-name": "Trazado 77",
    d: "M419.85,627.117V611.354L467.265,595.6l47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_78-3",
    "data-name": "Trazado 78",
    d: "M419.85,518.827V503.064l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_79-3",
    "data-name": "Trazado 79",
    d: "M419.85,410.537V394.774l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_80-3",
    "data-name": "Trazado 80",
    d: "M419.85,302.247V286.484l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_81-3",
    "data-name": "Trazado 81",
    d: "M419.85,193.957V178.194l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_82-3",
    "data-name": "Trazado 82",
    d: "M419.85,85.659V69.9L467.265,54.15,514.689,69.9V85.659L467.265,69.9Z",
    transform: "translate(-64.618 -8.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83-3",
    "data-name": "Trazado 83",
    d: "M0,85.659V69.9L47.415,54.15,94.839,69.9V85.659L47.415,69.9Z",
    transform: "translate(0 -8.334)",
    fill: "#ee4c39"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-4",
    "data-name": "Capa 2",
    transform: "translate(1023 81.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-4",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16-4",
    "data-name": "Trazado 16",
    d: "M69,789.547V773.793l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -116.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17-4",
    "data-name": "Trazado 17",
    d: "M216.46,789.547V773.793l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -116.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18-4",
    "data-name": "Trazado 18",
    d: "M348.79,789.547V773.793l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -116.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19-4",
    "data-name": "Trazado 19",
    d: "M69,681.257V665.5l47.415-15.763L163.839,665.5v15.754L116.415,665.5Z",
    transform: "translate(-10.62 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20-4",
    "data-name": "Trazado 20",
    d: "M216.46,681.257V665.5l47.415-15.763L311.29,665.5v15.754L263.875,665.5Z",
    transform: "translate(-33.315 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21-4",
    "data-name": "Trazado 21",
    d: "M348.79,681.257V665.5l47.415-15.763L443.629,665.5v15.754L396.205,665.5Z",
    transform: "translate(-53.681 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22-4",
    "data-name": "Trazado 22",
    d: "M69,572.967V557.213l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23-4",
    "data-name": "Trazado 23",
    d: "M216.46,572.967V557.213l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24-4",
    "data-name": "Trazado 24",
    d: "M348.79,572.967V557.213l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25-4",
    "data-name": "Trazado 25",
    d: "M69,464.677V448.923l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26-4",
    "data-name": "Trazado 26",
    d: "M216.46,464.677V448.923l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27-4",
    "data-name": "Trazado 27",
    d: "M348.79,464.677V448.923l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28-4",
    "data-name": "Trazado 28",
    d: "M69,356.387V340.633l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29-4",
    "data-name": "Trazado 29",
    d: "M216.46,356.387V340.633l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30-4",
    "data-name": "Trazado 30",
    d: "M348.79,356.387V340.633l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31-4",
    "data-name": "Trazado 31",
    d: "M69,248.1V232.343l47.415-15.763,47.424,15.763V248.1l-47.424-15.754Z",
    transform: "translate(-10.62 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32-4",
    "data-name": "Trazado 32",
    d: "M216.46,248.1V232.343l47.415-15.763,47.415,15.763V248.1l-47.415-15.754Z",
    transform: "translate(-33.315 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_33-4",
    "data-name": "Trazado 33",
    d: "M348.79,248.1V232.343l47.415-15.763,47.424,15.763V248.1l-47.424-15.754Z",
    transform: "translate(-53.681 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_34-4",
    "data-name": "Trazado 34",
    d: "M69,139.807V124.053l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_35-4",
    "data-name": "Trazado 35",
    d: "M216.46,139.807V124.053l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36-4",
    "data-name": "Trazado 36",
    d: "M348.79,139.807V124.053l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-53.681 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_37-4",
    "data-name": "Trazado 37",
    d: "M69,31.517V15.763L116.415,0l47.424,15.763V31.517L116.415,15.763Z",
    transform: "translate(-10.62)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_38-4",
    "data-name": "Trazado 38",
    d: "M216.46,31.517V15.763L263.875,0,311.29,15.763V31.517L263.875,15.763Z",
    transform: "translate(-33.315)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39-4",
    "data-name": "Trazado 39",
    d: "M348.79,31.517V15.763L396.205,0l47.424,15.763V31.517L396.205,15.763Z",
    transform: "translate(-53.681)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40-4",
    "data-name": "Trazado 40",
    d: "M140.64,735.407V719.644l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41-4",
    "data-name": "Trazado 41",
    d: "M281.28,735.407V719.644L328.7,703.89l47.424,15.754v15.763L328.7,719.644Z",
    transform: "translate(-43.291 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42-4",
    "data-name": "Trazado 42",
    d: "M0,735.407V719.644L47.415,703.89l47.424,15.754v15.763L47.415,719.644Z",
    transform: "translate(0 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43-4",
    "data-name": "Trazado 43",
    d: "M140.64,846.977V831.214l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44-4",
    "data-name": "Trazado 44",
    d: "M281.28,846.977V831.214L328.7,815.46l47.424,15.754v15.763L328.7,831.214Z",
    transform: "translate(-43.291 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45-4",
    "data-name": "Trazado 45",
    d: "M0,846.977V831.214L47.415,815.46l47.424,15.754v15.763L47.415,831.214Z",
    transform: "translate(0 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46-4",
    "data-name": "Trazado 46",
    d: "M69,681.257V665.5l47.415-15.763L163.839,665.5v15.754L116.415,665.5Z",
    transform: "translate(-10.62 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_47-4",
    "data-name": "Trazado 47",
    d: "M216.46,681.257V665.5l47.415-15.763L311.29,665.5v15.754L263.875,665.5Z",
    transform: "translate(-33.315 -99.999)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_48-4",
    "data-name": "Trazado 48",
    d: "M140.64,627.117V611.354L188.055,595.6l47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_49-4",
    "data-name": "Trazado 49",
    d: "M281.28,627.117V611.354L328.7,595.6l47.424,15.754v15.763L328.7,611.354Z",
    transform: "translate(-43.291 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_50-4",
    "data-name": "Trazado 50",
    d: "M0,627.117V611.354L47.415,595.6l47.424,15.754v15.763L47.415,611.354Z",
    transform: "translate(0 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51-4",
    "data-name": "Trazado 51",
    d: "M69,572.967V557.213l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_52-4",
    "data-name": "Trazado 52",
    d: "M216.46,572.967V557.213l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -83.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_53-4",
    "data-name": "Trazado 53",
    d: "M140.64,518.827V503.064l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_54-4",
    "data-name": "Trazado 54",
    d: "M281.28,518.827V503.064L328.7,487.31l47.424,15.754v15.763L328.7,503.064Z",
    transform: "translate(-43.291 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_55-4",
    "data-name": "Trazado 55",
    d: "M0,518.827V503.064L47.415,487.31l47.424,15.754v15.763L47.415,503.064Z",
    transform: "translate(0 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_56-4",
    "data-name": "Trazado 56",
    d: "M69,464.677V448.923l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_57-4",
    "data-name": "Trazado 57",
    d: "M216.46,464.677V448.923l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -66.666)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_58-4",
    "data-name": "Trazado 58",
    d: "M140.64,410.537V394.774l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_59-4",
    "data-name": "Trazado 59",
    d: "M281.28,410.537V394.774L328.7,379.02l47.424,15.754v15.763L328.7,394.774Z",
    transform: "translate(-43.291 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60-4",
    "data-name": "Trazado 60",
    d: "M0,410.537V394.774L47.415,379.02l47.424,15.754v15.763L47.415,394.774Z",
    transform: "translate(0 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_61-4",
    "data-name": "Trazado 61",
    d: "M69,356.387V340.633l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_62-4",
    "data-name": "Trazado 62",
    d: "M216.46,356.387V340.633l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -50)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_63-4",
    "data-name": "Trazado 63",
    d: "M140.64,302.247V286.484l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_64-4",
    "data-name": "Trazado 64",
    d: "M281.28,302.247V286.484L328.7,270.73l47.424,15.754v15.763L328.7,286.484Z",
    transform: "translate(-43.291 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_65-4",
    "data-name": "Trazado 65",
    d: "M0,302.247V286.484L47.415,270.73l47.424,15.754v15.763L47.415,286.484Z",
    transform: "translate(0 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66-4",
    "data-name": "Trazado 66",
    d: "M69,248.1V232.343l47.415-15.763,47.424,15.763V248.1l-47.424-15.754Z",
    transform: "translate(-10.62 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_67-4",
    "data-name": "Trazado 67",
    d: "M216.46,248.1V232.343l47.415-15.763,47.415,15.763V248.1l-47.415-15.754Z",
    transform: "translate(-33.315 -33.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_68-4",
    "data-name": "Trazado 68",
    d: "M140.64,193.957V178.194l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-21.645 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69-4",
    "data-name": "Trazado 69",
    d: "M281.28,193.957V178.194L328.7,162.44l47.424,15.754v15.763L328.7,178.194Z",
    transform: "translate(-43.291 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_70-4",
    "data-name": "Trazado 70",
    d: "M0,193.957V178.194L47.415,162.44l47.424,15.754v15.763L47.415,178.194Z",
    transform: "translate(0 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_71-4",
    "data-name": "Trazado 71",
    d: "M69,139.807V124.053l47.415-15.763,47.424,15.763v15.754l-47.424-15.754Z",
    transform: "translate(-10.62 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72-4",
    "data-name": "Trazado 72",
    d: "M216.46,139.807V124.053l47.415-15.763,47.415,15.763v15.754l-47.415-15.754Z",
    transform: "translate(-33.315 -16.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_73-4",
    "data-name": "Trazado 73",
    d: "M140.64,85.659V69.9L188.055,54.15,235.479,69.9V85.659L188.055,69.9Z",
    transform: "translate(-21.645 -8.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_74-4",
    "data-name": "Trazado 74",
    d: "M281.28,85.659V69.9L328.7,54.15,376.119,69.9V85.659L328.7,69.9Z",
    transform: "translate(-43.291 -8.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75-4",
    "data-name": "Trazado 75",
    d: "M419.85,735.407V719.644l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -108.333)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76-4",
    "data-name": "Trazado 76",
    d: "M419.85,846.977V831.214l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -125.505)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_77-4",
    "data-name": "Trazado 77",
    d: "M419.85,627.117V611.354L467.265,595.6l47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -91.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_78-4",
    "data-name": "Trazado 78",
    d: "M419.85,518.827V503.064l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -75)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_79-4",
    "data-name": "Trazado 79",
    d: "M419.85,410.537V394.774l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -58.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_80-4",
    "data-name": "Trazado 80",
    d: "M419.85,302.247V286.484l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -41.667)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_81-4",
    "data-name": "Trazado 81",
    d: "M419.85,193.957V178.194l47.415-15.754,47.424,15.754v15.763l-47.424-15.763Z",
    transform: "translate(-64.618 -25.001)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_82-4",
    "data-name": "Trazado 82",
    d: "M419.85,85.659V69.9L467.265,54.15,514.689,69.9V85.659L467.265,69.9Z",
    transform: "translate(-64.618 -8.334)",
    fill: "#ee4c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83-4",
    "data-name": "Trazado 83",
    d: "M0,85.659V69.9L47.415,54.15,94.839,69.9V85.659L47.415,69.9Z",
    transform: "translate(0 -8.334)",
    fill: "#ee4c39"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpulsoBg);
export default __webpack_public_path__ + "static/media/impulso-bg.9c73d2d7488d682c531a31d2d0fa8808.svg";
export { ForwardRef as ReactComponent };